import { Component, forwardRef, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';

//base

@Component({
  selector: 'my-changephonenumber-dialog',
  templateUrl: './ChangePhoneNumberDialog.component.html'
})
export class ChangePhoneNumberDialogComponent  {

    public displayDialog: boolean;
    phoneNumberToSave: string;
    employeeID: number;
    userInfo: ent.UserInfo;
    

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;

    @Output() public onCancel: EventEmitter<any> = new EventEmitter();
    @Output() public onYes: EventEmitter<ent.Response> = new EventEmitter();
    @Output() public onNo: EventEmitter<any> = new EventEmitter();

    constructor(private employeeService: serv.EmployeeService, private authenticationService: serv.AuthenticationService) 
    { 
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
    }

    public promptToUpdatePassword(requestPhoneNumber: string, employeePhoneNumber: string, employeeID: number){
        //console.info("promptToUpdatePassword requestPhoneNumber: " + requestPhoneNumber);
        //console.info("promptToUpdatePassword employeePhoneNumber: " + employeePhoneNumber);
        if (requestPhoneNumber != employeePhoneNumber){
            this.phoneNumberToSave = requestPhoneNumber;
            this.employeeID = employeeID;
            this.displayDialog = true;
        }
        else{
            this.onNo.emit(null);
        }
    }

    onHide(event: any){
        this.displayDialog = false;
    }

    onYesClick(event: any){
        var changePhoneNumberRequest: ent.ChangePhoneNumberRequest = {EmployeeID: this.employeeID, 
            NewPhoneNumber: this.phoneNumberToSave, SavedByEmployee: this.userInfo.Employee};
        this.employeeService.changePhoneNumber(changePhoneNumberRequest).subscribe(x=>{
            this.displayDialog = false;
            this.onYes.emit(x);
        });
        
        
    }

    onCancelClick(event: any){
        this.displayDialog = false;
        this.onCancel.emit(null);
    }

    onNoClick(event: any){
        this.displayDialog = false;
        this.onNo.emit(null);
    }
}